export default function Hero() {
  return (
    <section id="inicio" className="relative w-full overflow-hidden" style={{ height: '200vh' }}>
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/d3ca83f8b8eafc77a08882a35413daa8.jpg"
          alt="Taller de marquetería"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-8 flex flex-col justify-between py-64">
        <div className="mt-64">
          <h1 className="font-bold leading-tight max-w-4xl" style={{ fontSize: '12rem', fontFamily: 'Playfair Display, serif', color: '#F5E6D3', textShadow: '2px 2px 8px rgba(0,0,0,0.3)', letterSpacing: '0.02em' }}>
            Marquetería y Vidriería Hollywood
          </h1>
        </div>

        <div className="flex items-end justify-between">
          <a
            href="#cuadros"
            className="group bg-[#D4856C] text-white px-20 py-10 rounded-full flex items-center gap-8 hover:bg-[#C07560] transition-all cursor-pointer whitespace-nowrap"
          >
            <span className="text-3xl font-medium">Explorar servicios</span>
            <div className="w-24 h-24 bg-black rounded-full flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-4xl"></i>
            </div>
          </a>

          <div className="text-right">
            <p className="text-white text-5xl font-light max-w-2xl" style={{ fontFamily: 'Inter, sans-serif' }}>
              Arte, decoración y vidrio
            </p>
            <p className="text-white text-5xl font-light max-w-2xl" style={{ fontFamily: 'Inter, sans-serif' }}>
              con dedicación artesanal
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
